import React from 'react';

const ReasonCard = (props: any) => {
  const { icon, title, desc, iconType } = props;
  
  const renderIcon = () => {
    if (iconType === 'quality') {
      return (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      );
    }
    if (iconType === 'origin') {
      return (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      );
    }
    if (iconType === 'delivery') {
      return (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
        </svg>
      );
    }
    if (iconType === 'price') {
      return (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    }
    return icon;
  };

  return (
    <div className="w-full min-h-[240px] md:min-h-[280px] relative col-span-1 rounded-2xl overflow-hidden group cursor-pointer bg-white shadow-md hover:shadow-xl transition-all duration-500 border border-secondary/20 hover:border-secondary/40">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 via-secondary/10 to-secondary/5 group-hover:from-secondary/10 group-hover:via-secondary/20 group-hover:to-secondary/10 transition-all duration-500" />
      
      {/* Decorative circle */}
      <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-secondary/15 group-hover:bg-secondary/25 group-hover:scale-150 transition-all duration-700" />
      <div className="absolute -bottom-8 -left-8 w-24 h-24 rounded-full bg-secondary/15 group-hover:bg-secondary/25 group-hover:scale-150 transition-all duration-700 delay-100" />
      
      {/* Content */}
      <div className="relative z-10 h-full flex flex-col p-5 md:p-6">
        {/* Icon container */}
        <div className="mb-6 flex-shrink-0">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-secondary to-secondary/90 flex items-center justify-center text-white shadow-lg group-hover:shadow-xl group-hover:scale-110 group-hover:rotate-3 transition-all duration-500">
            {renderIcon()}
          </div>
        </div>
        
        {/* Text content */}
        <div className="flex flex-col gap-3 flex-1">
          <h3 className="font-bold text-[18px] md:text-[22px] text-gray-800 uppercase group-hover:text-secondary transition-colors duration-300">
            {title}
          </h3>
          <p className="text-[14px] md:text-[16px] text-gray-700 leading-relaxed group-hover:text-gray-800 transition-colors duration-300">
            {desc}
          </p>
        </div>
        
        {/* Arrow indicator */}
        <div className="mt-4 flex items-center gap-2 opacity-0 group-hover:opacity-100 transform translate-x-[-10px] group-hover:translate-x-0 transition-all duration-500">
          <div className="w-0 group-hover:w-8 h-[2px] bg-secondary transition-all duration-300" />
          <svg
            className="w-5 h-5 text-secondary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {/* <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            /> */}
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ReasonCard;
